import { BlockStack, Card, InlineGrid, SkeletonBodyText, Text } from '@shopify/polaris';
import { OrderStatusPalette } from '@/constants';
import { useGetShipmentOvertimeQuery } from '@/redux/api/api.caller';
import { useSelector } from 'react-redux';
import { datePickerSelector, titleDatePickerSelector } from '@/redux/features/dashboard.slice';
import { camelToRegularText, camelToSnakeCase } from '@/helpers';
import { CustomBadge } from '@/components';
import { useMemo } from 'react';
import { CURRENT_CYCLE_TITLE } from '@/components/DatePicker';
import { StyledShipmentOvertime } from './styled';

const ShipmentsOvertime = () => {
  const { start, end } = useSelector(datePickerSelector);
  const titleDatePicker = useSelector(titleDatePickerSelector);
  const isCurrentCycle = titleDatePicker === CURRENT_CYCLE_TITLE;
  const overtimeParams = isCurrentCycle
    ? { inCycle: true }
    : { fromDate: start.toISOString(), toDate: end.toISOString() };
  const { data, isFetching } = useGetShipmentOvertimeQuery(overtimeParams);

  const transformedData = useMemo(() => {
    if (data && data.data) {
      const allData = Object.entries(data.data.statusSummary).map(([key, value]) => {
        return {
          key,
          value,
          color: OrderStatusPalette[camelToSnakeCase(key).toUpperCase() as keyof typeof OrderStatusPalette],
        };
      });
      return allData.filter((data) => data.key !== 'all');
    }
    return [];
  }, [data]);

  return (
    <StyledShipmentOvertime>
      <Card>
        <BlockStack gap="400">
          <Text variant="headingMd" as="h2">
            Shipments by status
          </Text>

          {isFetching ? (
            <SkeletonBodyText lines={11} />
          ) : (
            <InlineGrid columns={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} gap="200">
              {transformedData.length > 0 &&
                transformedData.map(({ key, color, value }, index) => (
                  <div className="shipment-item" key={index}>
                    <CustomBadge
                      bgColor="white"
                      summary={key === 'notFound' ? 'No info' : camelToRegularText(key)}
                      status={color}
                    />
                    <p>{value}</p>
                  </div>
                ))}
            </InlineGrid>
          )}
        </BlockStack>
      </Card>
    </StyledShipmentOvertime>
  );
};

export default ShipmentsOvertime;
